module.exports = __webpack_public_path__ + "img/新聞英文.4dab8f69.png";